import React from 'react';
import { motion } from 'framer-motion';
export const TruthSection = () => {
  return <section className="py-24 bg-white border-y border-neutral-200" data-id="element-399">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-400">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-401">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-12 text-center" data-id="element-402">
            La verdad que nadie te está diciendo sobre la crisis
          </h2>

          <div className="prose prose-lg mx-auto text-neutral-700" data-id="element-403">
            <p className="text-xl text-center font-medium" data-id="element-404">
              En toda recesión, el dinero{' '}
              <strong className="text-brand-600" data-id="element-405">no desaparece.</strong>
              <br data-id="element-406" />
              <span className="text-2xl font-bold text-neutral-900 mt-2 block" data-id="element-407">
                Se concentra.
              </span>
            </p>

            <p className="mt-8" data-id="element-408">
              Los consumidores dejan de gastar en lo que perciben como un lujo.
            </p>
            <p data-id="element-409">
              Pero siguen gastando, y gastando bien, en lo que perciben como:
            </p>

            <div className="space-y-6 my-10" data-id="element-410">
              <div className="bg-cream p-6 rounded-xl border border-neutral-200" data-id="element-411">
                <h3 className="text-xl font-bold text-neutral-900 flex items-center gap-3 m-0 mb-2" data-id="element-412">
                  <span className="text-2xl" data-id="element-413">💊</span> Una solución urgente
                </h3>
                <p className="m-0 text-neutral-600" data-id="element-414">
                  Algo que resuelve un problema que les duele ahora mismo y no
                  pueden ignorar.
                </p>
              </div>

              <div className="bg-cream p-6 rounded-xl border border-neutral-200" data-id="element-415">
                <h3 className="text-xl font-bold text-neutral-900 flex items-center gap-3 m-0 mb-2" data-id="element-416">
                  <span className="text-2xl" data-id="element-417">📈</span> Una inversión
                </h3>
                <p className="m-0 text-neutral-600" data-id="element-418">
                  Algo que les va a traer más de lo que gastan. Donde el costo
                  de no contratarlo es mayor al costo de contratarlo.
                </p>
              </div>

              <div className="bg-cream p-6 rounded-xl border border-neutral-200" data-id="element-419">
                <h3 className="text-xl font-bold text-neutral-900 flex items-center gap-3 m-0 mb-2" data-id="element-420">
                  <span className="text-2xl" data-id="element-421">🚒</span> Un salvavidas
                </h3>
                <p className="m-0 text-neutral-600" data-id="element-422">
                  Algo que evita una pérdida mayor: de clientes, de reputación,
                  de tiempo, de dinero.
                </p>
              </div>
            </div>

            <div className="bg-brand-600 p-8 rounded-xl text-center my-12 shadow-md" data-id="element-423">
              <p className="text-xl font-bold text-white m-0 mb-2" data-id="element-424">
                El problema no es que no haya plata.
              </p>
              <p className="text-xl font-medium text-brand-100 m-0" data-id="element-425">
                El problema es que tu oferta no está posicionada como ninguna de
                estas tres cosas.
              </p>
            </div>

            <p data-id="element-426">
              El comprador argentino en 2026 analiza cada peso antes de moverlo.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-neutral-700 font-medium" data-id="element-427">
              <li data-id="element-428">Necesita más justificación.</li>
              <li data-id="element-429">Tiene más miedo de equivocarse.</li>
              <li data-id="element-430">
                Y se mueve únicamente cuando siente que NO contratarte le cuesta
                más que contratarte.
              </li>
            </ul>

            <p className="text-xl font-bold text-neutral-900 mt-8" data-id="element-431">
              Si tu mensaje no habla ese idioma, perdés la venta antes de que
              empiece.
            </p>

            <div className="text-center mt-12" data-id="element-432">
              <span className="inline-block border-2 border-brand-600 text-brand-700 font-bold px-6 py-3 rounded-lg text-xl bg-brand-50" data-id="element-433">
                CAJA DE COBRO te enseña ese idioma.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};